import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './rule-editors-layout.css';
function RuleEditorsLayout({ children, className }) {
    return _jsx("div", { className: classNames(styles.elementsList, className), children: children });
}
export default RuleEditorsLayout;
